<template>
  <div class="page-head">
<!--    <img src="../../assets/onlyLogo.png" style="width: 70px;display: inline-block;margin-right: 10px;vertical-align: middle">-->
    <div style="display: inline-block;vertical-align: middle">
<!--      <h1 class="home-description">-->
<!--        人脑功能图谱可视化-->
<!--        <div class="sub-title">Visualizing the functional mapping of human brain</div>-->
<!--      </h1>-->
      <img src="../../assets/newLogo.png" height="90"/>
      <a-divider type="vertical" style="height: 80px; background-color: white"/>
      <div class="standard-brain brain-button">
        {{ brainType }}
        <div class="menu-name">{{ menuName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pageTitle",
  props : {
    menuName : String,
    brainType : String
  }
}
</script>

<style scoped>
.page-head{
  display: inline-block;
  margin-left: 20px;
  margin-top: 20px;
  z-index: 99;
}
.home-description {
  display: inline-block;
  font-size: 2.0rem;
  font-weight: bold;
  color: white;
  vertical-align: middle;
}

.sub-title {
  font-size: 0.8rem;
  font-weight: normal;
}

.brain-button {
  background-color: #1F4E79;
  border-radius: 20px;
  display: inline-block;
  cursor: pointer;
  font-size: 2.0rem;
  height: 80px;
  text-align: center;
  vertical-align: top;
  color: white;
  font-weight: bold;
  padding: 0 20px;
}
.menu-name{
  font-size: 14px;
  font-weight: normal;
}
</style>